export const GET_MY_SUCCESS = "getMySuccess";
export const GET_MY_FAIL = "getMyFail";



export const GET_MOBILE_DETAILS_REQUEST = 'getMobileDetailsRequest';
export const GET_MOBILE_DETAILS_SUCCESS = 'getMobileDetailsSuccess';
export const GET_MOBILE_DETAILS_FAIL = 'getMobileDetailsFail';
export const GET_MOBILE_DETAILS_RESET = 'getMobileDetailsReset';

export const GET__STYLE_SUCCESS = "getStylesuccess";
export const GET_STYLE_FAIL = "getStyleFail";
